/**
 * Shared constants for onboarding wizard
 */

export const STEPS = [
  "1. Identificação",
  "2. Objetivos",
  "3. Diagnóstico Patrimonial",
  "4. Suitability CVM",
  "5. Jurídico & Tributário",
  "6. Checklist & Conclusão",
];
